import { render, staticRenderFns } from "./LocalThresholdEditWindow.vue?vue&type=template&id=7a8f3164&scoped=true"
import script from "./LocalThresholdEditWindow.vue?vue&type=script&lang=js"
export * from "./LocalThresholdEditWindow.vue?vue&type=script&lang=js"
import style0 from "./LocalThresholdEditWindow.vue?vue&type=style&index=0&id=7a8f3164&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8f3164",
  null
  
)

export default component.exports